if (!customElements.get('canalla-floating-atc')) {
  customElements.define('canalla-floating-atc', class extends HTMLElement {
    connectedCallback() {
      this.source = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
      this.originalButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
      if (!this.source || !this.originalButton) return;

      this.button = this.querySelector('[data-floating-submit]');
      this.label = this.querySelector('[data-floating-label]');
      this.price = this.querySelector('[data-floating-price]');
      this.variant = this.querySelector('[data-floating-variant]');
      this.error = this.querySelector('[data-floating-error]');
      this.spinner = this.querySelector('.loading__spinner');
      this.onClick = () => {
        this.sync();
        if (!this.button.disabled) this.originalButton.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.sourceObserver = new MutationObserver(() => this.sync());
      this.sourceObserver.observe(this.source, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'],
      });
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.visibilityObserver.observe(this.originalButton);
      this.sizeObserver = new ResizeObserver(([entry]) => {
        if (!this.hidden && entry.target.offsetHeight) {
          document.body.style.setProperty('--canalla-floating-atc-height', `${entry.target.offsetHeight}px`);
        }
      });
      this.sizeObserver.observe(this);
      this.sync();
    }

    sync() {
      const busy = this.originalButton.classList.contains('loading');
      this.button.disabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
      this.button.setAttribute('aria-busy', String(busy));
      this.button.classList.toggle('loading', busy);
      this.spinner?.classList.toggle('hidden', !busy);
      this.label.textContent = this.originalButton.querySelector('span')?.textContent.trim() || '';

      const sourcePrice = document.getElementById(`price-${this.dataset.sectionId}`);
      const currentPrice = sourcePrice?.querySelector('.price--on-sale .price-item--sale')
        || sourcePrice?.querySelector('.price__regular .price-item--regular');
      this.price.hidden = !currentPrice || sourcePrice.classList.contains('hidden');
      if (currentPrice) this.price.textContent = currentPrice.textContent.trim();

      const selectedVariant = this.source.querySelector('variant-selects [data-selected-variant]');
      let variant;
      try {
        variant = selectedVariant ? JSON.parse(selectedVariant.textContent) : null;
      } catch {
        variant = null;
      }
      this.variant.textContent = this.dataset.defaultVariant === 'false' ? variant?.title || '' : '';
      this.variant.hidden = !this.variant.textContent;

      const errorWrapper = this.source.querySelector('product-form .product-form__error-message-wrapper');
      const errorText = errorWrapper && !errorWrapper.hidden
        ? errorWrapper.querySelector('.product-form__error-message')?.textContent.trim() || ''
        : '';
      if (this.error.textContent !== errorText) this.error.textContent = errorText;
      this.error.hidden = !errorText;
    }

    disconnectedCallback() {
      this.sourceObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.sizeObserver?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
